module.exports = __webpack_public_path__ + "static/gumtree-paypal-macbook.116fc3d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/gumtree-paypal/gumtree-paypal-macbook.jpg
// module id = 460
// module chunks = 181503948081111